// VITE_BACKEND_BASE_URL already includes the /api/v1 base path, so endpoint
// paths must be relative to it (matching secretEncryptionEndpoints).
const customerPurgeEndpoints = {
  confirm: (businessKey: string) => `/admin/customers/${businessKey}/purge/confirm`,
};

export default customerPurgeEndpoints;
